import type { QueryClient } from "@tanstack/react-query";
import { storesQueryOptions } from "@/hooks/use-stores";

/**
 * Resolves the store id for a slug from the cached stores list (shared with the
 * sidebar / `beforeLoad`), so route loaders can prefetch store-scoped data
 * without an extra request.
 */
export async function resolveStoreId(
	queryClient: QueryClient,
	slug: string,
): Promise<string | undefined> {
	const stores = await queryClient.ensureQueryData(storesQueryOptions);
	return stores.find((store) => store.slug === slug)?.id;
}
